// Adobe RGB: 0.778, 0.377, 0.405
export const PRIMARY_COLOR = "#C66067";
// Adobe RGB: 0.438, 0.681, 0.722
export const SECONDARY_COLOR = "#70AEB8";

export const EVENT_NAME = "North America: DIGITAL TWIN 2026";
export const EVENT_LOCATION = "THE CURTIS HOTEL, DENVER, USA";
export const CONFERENCE_DAY = "19";
export const WORKSHOPS_DAY = "20";
export const CONFERENCE_DATE = "AUGUST 19, 2026";
export const WORKSHOPS_DATE = "AUGUST 20, 2026";
export const EVENT_DATES_SHORT = "AUGUST 19–20, 2026";
export const EVENT_WEBSITE = "https://usa.digitaltwin-summit.com";

export const apiToken =
  "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudElkIjoiOWY3MGZlMzQtN2Q0Yi0xMWVkLWExZWItMDI0MmFjMTIwMDI1IiwiY3VzdG9tZXJJZCI6ImQxYjkxMGZhLTMxYTgtMTFlZC1hMjYxLTAyNDJhYzEyMDAwMiIsImhvc3QiOiJodHRwczovL2VnLmRpZ2l0YWx0d2luLXN1bW1pdC5jb20iLCJpYXQiOjE3MzE1MDc3MTEsImF1ZCI6ImV4cC5jb20iLCJpc3MiOiJleHAtcHJvdmlkZXIiLCJzdWIiOiJhZG1pbkBleHAuY29tIn0.baMM3WygUlwyPbizcl44QMjZySRjyp2ap6Y_1CTNHf1Jog1YXRmoU7O-fnbiGOXOSjti8Nv4J-QHYdbFLreKOPcZa0d-lLlSH_m8rH4kVyzGSnWMbC-Zc4-XFZCVOQXm5Zub85d1t0MsV9fT1ANHphnJLW2VEfzBRBDWx0tnPx8";

export const newToken =
  "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudElkIjoiZDllMDMzMzItMWQ1NS0xMWVlLWJlNTYtMDI0MmFjMTIwMDI4IiwiY3VzdG9tZXJJZCI6ImQxYjkxMGZhLTMxYTgtMTFlZC1hMjYxLTAyNDJhYzEyMDAwMiIsImhvc3QiOiJodHRwczovL3VzYS5kaWdpdGFsdHdpbi1zdW1taXQuY29tIiwiaWF0IjoxNzc5MzI2Mzg0LCJhdWQiOiJleHAuY29tIiwiaXNzIjoiZXhwLXByb3ZpZGVyIiwic3ViIjoiYWRtaW5AZXhwLmNvbSJ9.HEvPTPEqtZHIhSIDLc6Cc-3lnxF6_hmcsy2Rchm_KSD2SO7zPlymTtR6kpJnCQb4zepdvS4cM9Jr8SvfRtIT1KRnRbD7BO4RQVZIOF7KX2TYuwHW36Yz6QQMbGHCl37RTEWynYV_ov_XcbSQAlrKzUw5Zafx87JJjfN55d2-lzE";

export const apiUrl = "https://api.rapid-events.com";
